import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BadgeComponent } from '../../../atoms/badge/badge.component';

@Component({
  selector: 'htx-step-header',
  standalone: true,
  imports: [CommonModule, BadgeComponent],
  templateUrl: './step-header.component.html',
  styleUrl: './step-header.component.scss'
})
export class StepHeaderComponent {
  badge = input<string>('');
  title = input<string>('');
  descriptions = input<string[]>([]);
}
